<template>
  <div style="margin: -15px">
    <div style="padding: 10px; height: calc(100vh - 179px); overflow-y: auto">
      <el-form
        ref="financialRef"
        :disabled="disabled"
        :model="ruleForm"
        label-position="top"
        size="small"
      >
        <div>
          <!--基础数据-->
          <div class="title-cmp">{{ $t('basicData.UnderlyingData') }}</div>
          <el-row :gutter="10">
            <el-col :span="8">
              <!-- 报价方式 -->
              <el-form-item
                :label="$t('customerManagements.priceTerms')"
                :rules="[
                  {
                    required: true,
                    message: $t('collectionCenter.pleaseChoose'),
                    trigger: ['change', 'blur']
                  }
                ]"
                prop="billingMethod"
              >
                <el-select
                  v-model="ruleForm.billingMethod"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  clearable
                  style="width: 100%"
                >
                  <el-option :label="$t('customerManagements.oneParagraph')" :value="0" />
                  <el-option :label="$t('customerManagements.twoParagraph')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 结算方式 -->
              <el-form-item
                :label="$t('receivablePayable.paymentMethod')"
                :rules="[
                  {
                    required: true,
                    message: $t('collectionCenter.pleaseChoose'),
                    trigger: ['change', 'blur']
                  }
                ]"
                prop="settlementMethod"
              >
                <el-select
                  v-model="ruleForm.settlementMethod"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  clearable
                  style="width: 100%"
                >
                  <el-option :label="$t('basicData.PeriodicSettlement')" :value="0" />
                  <el-option :label="$t('basicData.RechargeSettlement')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!--材积计费-->
          <div class="title-cmp">
            {{ $t('customerManagements.VolumeCharging') }}
          </div>
          <el-row :gutter="10">
            <el-col :span="8">
              <!--材积计费-->
              <el-form-item
                :label="$t('customerManagements.VolumeCharging')"
                prop="useVolumeBilling"
              >
                <el-switch
                  v-model="ruleForm.useVolumeBilling"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#00A551"
                  inactive-color="#ff4949"
                  :disabled="disabled"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="ruleForm.useVolumeBilling === 1" :gutter="10">
            <el-col :span="5">
              <!--快递小件-->
              <el-form-item
                :label="$t('customerManagements.ExpressSmallParcel')"
                :rules="[
                  {
                    required:
                      (ruleForm.useVolumeBilling === 1 &&
                        (ruleForm.largeCalculateBase === null ||
                          ruleForm.largeCalculateBase === '' ||
                          ruleForm.largeCalculateBase === undefined)) ||
                      ruleForm.smallCalculateBase ||
                      ruleForm.smallCalculateBase === 0,
                    message: $t('collectionCenter.pleaseChoose'),
                    trigger: ['change', 'blur']
                  }
                ]"
                prop="smallCalculationMethod"
              >
                <el-select
                  v-model="ruleForm.smallCalculationMethod"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  clearable
                  style="width: 100%"
                  :disabled="disabled"
                >
                  <el-option :value="0" label="*" />
                  <el-option :value="1" label="/" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--计算基数-->
              <el-form-item
                :rules="[{ validator: validateBase, trigger: ['change', 'blur'] }]"
                prop="smallCalculateBase"
              >
                <el-input
                  v-model="ruleForm.smallCalculateBase"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  style="width: 200px; margin-top: 28px"
                  @input="changeSmall"
                  :disabled="disabled"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="ruleForm.useVolumeBilling === 1" :gutter="10">
            <el-col :span="5">
              <!--快递大件-->
              <el-form-item
                :label="$t('customerManagements.ExpressLargeParcel')"
                :rules="[
                  {
                    required:
                      (ruleForm.useVolumeBilling === 1 &&
                        (ruleForm.smallCalculateBase === null ||
                          ruleForm.smallCalculateBase === '' ||
                          ruleForm.smallCalculateBase === undefined)) ||
                      ruleForm.largeCalculateBase ||
                      ruleForm.largeCalculateBase === 0,
                    message: $t('collectionCenter.pleaseChoose'),
                    trigger: ['change', 'blur']
                  }
                ]"
                prop="largeCalculationMethod"
              >
                <el-select
                  v-model="ruleForm.largeCalculationMethod"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  clearable
                  style="width: 100%"
                  :disabled="disabled"
                >
                  <el-option :value="0" label="*" />
                  <el-option :value="1" label="/" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="19" class="flex_item_center">
              <!--计算基数-->
              <el-form-item
                :rules="[{ validator: validateBase, trigger: ['change', 'blur'] }]"
                prop="largeCalculateBase"
              >
                <el-input
                  v-model="ruleForm.largeCalculateBase"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  style="width: 200px; margin-top: 28px"
                  @input="changeSmall"
                  :disabled="disabled"
                />
              </el-form-item>
              <div class="flex_item_center">
                <div style="margin: 0 10px">
                  {{ $t('customerManagements.bulkVolumeDiscountFactor') }}
                </div>
                <el-tooltip class="QuestionMark" placement="top">
                  <div slot="content">
                    <div>{{ $t('customerManagements.dimensionalWeightDiscountNotice') }}</div>
                    <div style="text-align: center">
                      {{ $t('customerManagements.finalBillingWeightFormula') }}
                    </div>
                  </div>
                  <svg-icon icon-class="QuestionMark" />
                </el-tooltip>
                <el-switch
                  v-model="ruleForm.useLargeVolumeDiscount"
                  :active-value="1"
                  :inactive-value="0"
                  active-color="#00A551"
                  inactive-color="#ff4949"
                  style="margin: 0 10px"
                  @change="changeLargeVolumeDiscount"
                />
                <el-form-item
                  v-if="ruleForm.useLargeVolumeDiscount === 1"
                  :rules="[
                    {
                      required: true,
                      message: $t('customerManagements.pleaseInput'),
                      trigger: ['change', 'blur']
                    },
                    {
                      type: 'integer',
                      message: $t('customerManagements.integerOnly'),
                      trigger: ['change', 'blur']
                    },
                    {
                      pattern: /^(?:[1-9]\d?|100)$/,
                      message: $t('customerManagements.integerBetween1And100'),
                      trigger: ['change', 'blur']
                    }
                  ]"
                  prop="largeVolumeDiscountRate"
                  style="margin-top: 20px"
                >
                  <el-input
                    v-model.number="ruleForm.largeVolumeDiscountRate"
                    :maxlength="3"
                    :placeholder="$t('customerManagements.pleaseInput')"
                    clearable
                    style="width: 100px"
                  />
                </el-form-item>
                <div v-if="ruleForm.useLargeVolumeDiscount === 1" style="margin-left: 6px">%</div>
              </div>
            </el-col>
          </el-row>
          <!--费用生成节点-->
          <div class="title-cmp">{{ $t('customerManagements.FeeGenerationNode') }}</div>
          <el-row :gutter="10">
            <el-col :span="8">
              <!--快递业务-->
              <el-form-item
                :label="$t('customerManagements.ExpressBusiness')"
                :rules="[
                  {
                    required: true,
                    message: $t('operationCenter.PleaseSelect'),
                    trigger: ['change', 'blur']
                  }
                ]"
                prop="expressFeeNode"
              >
                <el-select
                  v-model="ruleForm.expressFeeNode"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  style="width: 100%"
                >
                  <el-option
                    :key="1"
                    :label="$t('customerManagements.OrderNode')"
                    :value="0"
                  /><!--下单节点-->
                  <el-option
                    :key="2"
                    :label="$t('customerManagements.PickupNode')"
                    :value="1"
                  /><!--揽收节点-->
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--揽收业务-->
              <el-form-item
                :label="$t('customerManagements.PickupBusiness')"
                :rules="[
                  {
                    required: true,
                    message: $t('operationCenter.PleaseSelect'),
                    trigger: ['change', 'blur']
                  }
                ]"
                prop="collectFeeNode"
              >
                <el-select
                  v-model="ruleForm.collectFeeNode"
                  :placeholder="$t('operationCenter.PleaseSelect')"
                  style="width: 100%"
                >
                  <el-option
                    :key="1"
                    :label="$t('customerManagements.OrderNode')"
                    :value="0"
                  /><!--下单节点-->
                  <el-option
                    :key="2"
                    :label="$t('customerManagements.PickupNode')"
                    :value="1"
                  /><!--揽收节点-->
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!--其他信息-->
          <div class="title-cmp">{{ $t('customerManagements.OtherInformation') }}</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <!-- 财务联系人 -->
              <el-form-item
                :label="$t('customerManagements.FinancialContactPerson')"
                prop="financeContactsName"
              >
                <el-input
                  v-model.trim="ruleForm.financeContactsName"
                  :placeholder="$t('customerManagements.pleaseInput')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 财务联系人手机 -->
              <el-form-item
                :label="$t('customerManagements.FinancialContactPersonPhone')"
                :rules="[{ required: false, validator: checkNumber, trigger: ['change', 'blur'] }]"
                prop="financeContactsPhone"
              >
                <el-input
                  v-model.trim="ruleForm.financeContactsPhone"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  maxlength="20"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <!-- 财务联系人电话 -->
              <el-form-item :label="$t('customerManagements.FinancialContactPersonTel')">
                <el-input
                  v-model.trim="ruleForm.financeContactsTel"
                  :placeholder="$t('customerManagements.pleaseInput')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 财务联系人邮箱 -->
              <el-form-item
                :label="$t('customerManagements.FinancialContactPersonEmail')"
                :rules="[{ required: false, validator: checkEmail, trigger: ['change', 'blur'] }]"
                prop="financeContactsEmail"
              >
                <el-input
                  v-model.trim="ruleForm.financeContactsEmail"
                  :placeholder="$t('customerManagements.pleaseInput')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <!-- 财务联系人QQ -->
              <el-form-item
                :label="$t('customerManagements.FinancialContactPersonQQ')"
                :rules="[{ required: false, validator: checkNumber, trigger: ['change', 'blur'] }]"
                prop="financeContactsQq"
              >
                <el-input
                  v-model.trim="ruleForm.financeContactsQq"
                  :placeholder="$t('customerManagements.pleaseInput')"
                  maxlength="11"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div
      v-if="customerType.type === 'add' || customerType.type === 'edit'"
      style="text-align: right; padding: 10px; border-top: 1px solid #ccc"
    >
      <div v-permit:remove="'btn:customer-managements:list:financialEdite'">
        <el-button size="small" type="primary" @click="submitForm()">{{ $t('collectionCenter.submit') }}
        </el-button>
        <el-button size="small" @click="cancelWindow">{{ $t('collectionCenter.cancel') }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getCustomerFinance, updateCustomerFinance } from '@/api/customer';

export default {
  name: 'FinancialCmp',
  props: {
    customerType: {
      type: Object,
      default() {
        return {
          id: '',
          type: 'add'
        };
      }
    }
  },
  data() {
    const validateBase = (rule, value, callback) => {
      const regex = /^(0|[1-9]\d{0,8})(\.\d{1,2})?$/;
      if (rule.field === 'smallCalculateBase') {
        if (
          this.ruleForm.largeCalculateBase === null ||
          this.ruleForm.largeCalculateBase === '' ||
          this.ruleForm.largeCalculateBase === undefined
        ) {
          if (value === null || value === undefined || value === '') {
            callback(new Error(this.$t('customerManagements.notNull')));
          } else {
            if (regex.test(value)) {
              callback();
            } else {
              callback(new Error(this.$t('collectionCenter.hint')));
            }
          }
        } else {
          callback();
        }
      } else if (rule.field === 'largeCalculateBase') {
        if (
          this.ruleForm.smallCalculateBase === null ||
          this.ruleForm.smallCalculateBase === '' ||
          this.ruleForm.smallCalculateBase === undefined
        ) {
          if (value === null || value === undefined || value === '') {
            callback(new Error(this.$t('customerManagements.notNull')));
          } else {
            if (regex.test(value)) {
              callback();
            } else {
              callback(new Error(this.$t('collectionCenter.hint')));
            }
          }
        } else {
          callback();
        }
      }
    };
    // 大于等于0的数字
    const checkNumber = (rule, value, callback) => {
      const regex = /^\d+$/;
      if (!value) {
        callback();
      } else {
        if (!regex.test(value)) {
          callback(new Error(this.$t('mdfeTranslate.OnlyNumbersCanBeEntered'))); // 必须是大于或等于0的正整数
        } else {
          callback();
        }
      }
    };
    // 邮箱校验
    const checkEmail = (rule, value, callback) => {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!value) {
        callback();
      } else {
        if (!regex.test(value)) {
          callback(new Error(this.$t('collectionCenter.emailNotFormat')));
        } else {
          callback();
        }
      }
    };
    return {
      ruleForm: {
        useLargeVolumeDiscount: 0, // 是否使用大件材积折扣系数(0:否,1:是)
        largeVolumeDiscountRate: '', // 材积计费-大件材积折扣系数
        billingMethod: null, // 报价方式
        settlementMethod: null, // 结算方式
        useVolumeBilling: 0, // 是否使用材积计费，（0：否；1：是）
        smallCalculationMethod: 0, // 小件计算方式(0:*,1:/)
        smallCalculateBase: null, // 小件计算基数
        largeCalculationMethod: 0, // 大件计算方式(0:*,1:/)
        largeCalculateBase: null, // 大件计算基数
        expressFeeNode: 0, // 快递业务
        collectFeeNode: 1, // 揽收业务
        financeContactsName: null, // 财务联系人姓名
        financeContactsPhone: null, // 财务联系人手机
        financeContactsTel: null, // 财务联系人电话
        financeContactsEmail: null, // 财务联系人邮箱
        financeContactsQq: null // 财务联系人QQ
      },
      validateBase,
      checkNumber,
      checkEmail,
      disabled: false
    };
  },
  watch: {
    customerType: {
      handler(newVal) {
        this.resetRuleForm();
        if (newVal.type === 'examine' || newVal.type === 'set') {
          this.disabled = true;
        } else if (newVal.type === 'edit' || newVal.type === 'add') {
          this.disabled = false;
        }
        if (newVal.type === 'add') {
          // 新增
          return;
        }
        this.ruleForm.customerId = newVal.id;
        this.getCustomerData(newVal.id);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changeLargeVolumeDiscount() {
      this.ruleForm.largeVolumeDiscountRate = '';
    },
    // 重置form校验
    changeSmall() {
      this.$nextTick(() => {
        this.$refs.financialRef.clearValidate([
          'largeCalculateBase',
          'largeCalculationMethod',
          'smallCalculateBase',
          'smallCalculationMethod'
        ]);
      });
    },
    // 清空数据
    resetRuleForm() {
      for (const key in this.ruleForm) {
        this.ruleForm[key] = null;
      }
      this.ruleForm.useVolumeBilling = 0;
      this.ruleForm.expressFeeNode = 0;
      this.ruleForm.collectFeeNode = 1;
      this.ruleForm.smallCalculationMethod = 0;
      this.ruleForm.largeCalculationMethod = 0;
      this.ruleForm.useLargeVolumeDiscount = 0;
    },
    // 提交表单
    submitForm() {
      this.$refs.financialRef.validate((valid) => {
        console.log(valid, '===valid===');
        if (valid) {
          updateCustomerFinance(this.ruleForm).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.cancelWindow();
            }
          });
        } else {
          console.log(this.ruleForm);
        }
      });
    },
    // 取消
    cancelWindow() {
      this.$emit('updataData', true);
    },
    // 获取数据
    getCustomerData(ids) {
      getCustomerFinance(ids)
        .then((res) => {
          if (res.code === 200) {
            const {
              customerId,
              financeContactsName,
              financeContactsPhone,
              financeContactsTel,
              financeContactsEmail,
              financeContactsQq,
              useVolumeBilling,
              smallCalculationMethod,
              smallCalculateBase,
              largeCalculationMethod,
              largeCalculateBase,
              billingMethod,
              settlementMethod,
              expressFeeNode,
              collectFeeNode,
              useLargeVolumeDiscount,
              largeVolumeDiscountRate
            } = res.data;
            const obj = {
              customerId,
              financeContactsName,
              financeContactsPhone,
              financeContactsTel,
              financeContactsEmail,
              financeContactsQq,
              useVolumeBilling,
              smallCalculationMethod,
              smallCalculateBase,
              largeCalculationMethod,
              largeCalculateBase,
              billingMethod,
              settlementMethod,
              useLargeVolumeDiscount,
              largeVolumeDiscountRate,
              expressFeeNode: expressFeeNode || 0,
              collectFeeNode: collectFeeNode || 1
            };
            // 材积计费处理
            if (useVolumeBilling === 1) {
              // 选中了
              obj.useVolumeBilling = useVolumeBilling;
              obj.smallCalculationMethod = smallCalculationMethod;
              obj.smallCalculateBase = smallCalculateBase;
              obj.largeCalculationMethod = largeCalculationMethod;
              obj.useLargeVolumeDiscount = useLargeVolumeDiscount;
              obj.largeCalculateBase = largeCalculateBase;
              obj.largeVolumeDiscountRate = largeVolumeDiscountRate;
            } else {
              obj.useVolumeBilling = 0;
              obj.smallCalculationMethod = 0;
              obj.smallCalculateBase = null;
              obj.largeCalculationMethod = 0;
              obj.useLargeVolumeDiscount = 0;
              obj.largeCalculateBase = null;
              obj.largeVolumeDiscountRate = '';
            }
            Object.assign(this.ruleForm, obj);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
.title-cmp {
  border-bottom: 2px solid #ddd;
  padding: 10px 0;
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: bold;
  color: #12B866;
}
</style>
